import {Tab, Tabs, TabSpacer} from '../../components/Tab/Tabs';
import {PlantingProjectType} from '../../entities';

export enum PlantingProjectView {
    Default = 0,
    Reforestation = 1,
    Community = 2,
    Carbon = 3,
    CommunityTreeDistributor = 5,
    MembershipTrees = 6
}

export function getViewForProjectType(projectType: PlantingProjectType) {
    switch (projectType) {
        case PlantingProjectType.Reforestation:
            return PlantingProjectView.Reforestation;
        case PlantingProjectType.CommunityEvent:
            return PlantingProjectView.Community;
        case PlantingProjectType.Carbon:
            return PlantingProjectView.Carbon;
        case PlantingProjectType.CommunityTreeDistributor:
            return PlantingProjectView.CommunityTreeDistributor;
        case PlantingProjectType.MembershipTrees:
            return PlantingProjectView.MembershipTrees;
        default:
            return undefined;
    }
}

export function showReforestationColumn(view: PlantingProjectView) {
    switch (view) {
        case PlantingProjectView.Default:
            return true;
        case PlantingProjectView.Reforestation:
            return true;
        default:
            return false;
    }
}

export function showCommunityColumn(view: PlantingProjectView) {
    switch (view) {
        case PlantingProjectView.Default:
            return true;
        case PlantingProjectView.Community:
            return true;
        default:
            return false;
    }
}

export function showCarbonColumn(view: PlantingProjectView) {
    switch (view) {
        case PlantingProjectView.Default:
            return true;
        case PlantingProjectView.Carbon:
            return true;
        default:
            return false;
    }
}

export function showCommunityTreeDistributorColumn(view: PlantingProjectView) {
    switch (view) {
        case PlantingProjectView.Default:
        case PlantingProjectView.CommunityTreeDistributor:
            return true;
        default:
            return false;
    }
}

export function showMembershipTreesColumn(view: PlantingProjectView) {
    switch (view) {
        case PlantingProjectView.Default:
        case PlantingProjectView.MembershipTrees:
            return true;
        default:
            return false;
    }
}

export function getProjectTypeForView(view: PlantingProjectView) {
    switch (view) {
        case PlantingProjectView.Reforestation:
            return PlantingProjectType.Reforestation;
        case PlantingProjectView.Community:
            return PlantingProjectType.CommunityEvent;
        case PlantingProjectView.Carbon:
            return PlantingProjectType.Carbon;
        case PlantingProjectView.CommunityTreeDistributor:
            return PlantingProjectType.CommunityTreeDistributor;
        case PlantingProjectView.MembershipTrees:
            return PlantingProjectType.MembershipTrees;
        default:
            throw new Error('No specific project type for default view');
    }
}

function PlantingProjectViewSelector({
    view,
    changeView,
    allowViewChange,
    proposalMode = false
}: {
    view: PlantingProjectView;
    changeView: (view: PlantingProjectView) => void;
    allowViewChange: boolean;
    proposalMode?: boolean;
}) {
    return (
        <Tabs>
            {(allowViewChange || view === PlantingProjectView.Default) && (
                <>
                    <Tab
                        active={view === PlantingProjectView.Default}
                        onClick={() => changeView(PlantingProjectView.Default)}>
                        All
                    </Tab>
                    <TabSpacer />
                </>
            )}
            {(allowViewChange || view === PlantingProjectView.Reforestation) && (
                <>
                    <Tab
                        active={view === PlantingProjectView.Reforestation}
                        onClick={() => changeView(PlantingProjectView.Reforestation)}>
                        Reforestation
                    </Tab>
                    <TabSpacer />
                </>
            )}
            {(allowViewChange || view == PlantingProjectView.Community) && (
                <>
                    <Tab
                        active={view === PlantingProjectView.Community}
                        onClick={() => changeView(PlantingProjectView.Community)}>
                        Community
                    </Tab>
                    <TabSpacer />
                </>
            )}
            {!proposalMode && (allowViewChange || view == PlantingProjectView.Carbon) && (
                <>
                    <Tab
                        active={view === PlantingProjectView.Carbon}
                        onClick={() => changeView(PlantingProjectView.Carbon)}>
                        Carbon Credits
                    </Tab>
                    <TabSpacer />
                </>
            )}
            {!proposalMode && (allowViewChange || view == PlantingProjectView.CommunityTreeDistributor) && (
                <Tab
                    active={view === PlantingProjectView.CommunityTreeDistributor}
                    onClick={() => changeView(PlantingProjectView.CommunityTreeDistributor)}>
                    Community Tree Distributor
                </Tab>
            )}
            {!proposalMode && (allowViewChange || view == PlantingProjectView.MembershipTrees) && (
                <Tab
                    active={view === PlantingProjectView.MembershipTrees}
                    onClick={() => changeView(PlantingProjectView.MembershipTrees)}>
                    Membership Trees
                </Tab>
            )}
        </Tabs>
    );
}

export default PlantingProjectViewSelector;
